


const InputRowGroup = ({label, children}) => {
    return (
        <div className={'form-input-area'}>
            {label &&
                <h2>{label}</h2>
            }
            {children}
        </div>
    )
}

export default InputRowGroup;